export const JSON_ONE1 = {
   
    "status": "Valid UPI ID",
    "custVPA": "timishbenday@okhdfcbank",
    "payerName": "TIMISH BENDAY",
    "orderNo": "050506565_test",
    "merchantId": "201910300123"
    }
        

